import { render, staticRenderFns } from "./faqComponent.vue?vue&type=template&id=738efc56"
import script from "./faqComponent.vue?vue&type=script&lang=js"
export * from "./faqComponent.vue?vue&type=script&lang=js"
import style0 from "./faqComponent.vue?vue&type=style&index=0&id=738efc56&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports